module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong_point/1_36da00bce6b6a7dc8355b9c540833848.png";